import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const LoginPage: React.FC = () => {
  const { login, loading } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.username || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await login(formData.username, formData.password);
      // Login successful - AuthContext will handle navigation
    } catch (err: any) {
      const errorMessage = err.message || 'Login failed';
      if (errorMessage.includes('Invalid credentials')) {
        setError('Invalid username or password. Please check your credentials and try again.');
      } else {
        setError(errorMessage);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="ah-shell">
        <div className="ah-panel" style={{ maxWidth: 400, margin: '10vh auto' }}>
          <div className="ah-card" style={{ textAlign: 'center' }}>
            <div>Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ah-shell">
      <div className="ah-panel" style={{ maxWidth: 400, margin: '10vh auto' }}>
        <div className="ah-card">
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h1 className="ah-title">BEP Dashboard</h1>
            <p className="muted">Sign in to access the after hours system</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label htmlFor="username" style={{ display: 'block', marginBottom: 6, fontSize: 14, fontWeight: 500 }}>
                Username or Email
              </label>
              <input
                type="text"
                id="username"
                name="username"
                className="ah-input"
                value={formData.username}
                onChange={handleChange}
                placeholder="Enter your username or email"
                disabled={isSubmitting}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label htmlFor="password" style={{ display: 'block', marginBottom: 6, fontSize: 14, fontWeight: 500 }}>
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="ah-input"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                disabled={isSubmitting}
              />
            </div>

            {error && (
              <div style={{ 
                color: '#e53e3e', 
                fontSize: 14, 
                marginBottom: 16, 
                padding: 12, 
                backgroundColor: '#fed7d7', 
                border: '1px solid #feb2b2', 
                borderRadius: 6 
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              className="ah-btn"
              disabled={isSubmitting || !formData.username || !formData.password}
              style={{ width: '100%', justifyContent: 'center' }}
            >
              {isSubmitting ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div style={{ marginTop: 20, padding: 16, backgroundColor: 'var(--surface-hover)', borderRadius: 8 }}>
            <h4 style={{ margin: '0 0 8px 0', fontSize: 14 }}>Default Login:</h4>
            <p style={{ margin: 0, fontSize: 12, color: 'var(--muted)' }}>
              Username: <strong>admin</strong><br />
              Password: <strong>admin123</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;